import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import jaCommon from "./ja/common.json";
import jaLearner from "./ja/learner.json";
import enCommon from "./en/common.json";
import enLearner from "./en/learner.json";
import idCommon from "./id/common.json";
import idLearner from "./id/learner.json";
import { LOCALES } from "./locales";

const stored = localStorage.getItem("locale");
const initialLng = LOCALES.some((l) => l.code === stored) ? stored! : "ja";

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      ja: { common: jaCommon, learner: jaLearner },
      en: { common: enCommon, learner: enLearner },
      id: { common: idCommon, learner: idLearner },
    },
    lng: initialLng,
    fallbackLng: "ja",
    ns: ["common", "learner"],
    defaultNS: "learner",
    interpolation: { escapeValue: false },
  });

export default i18n;
